// extracted by mini-css-extract-plugin
export var icon = "kahOE797XA_ZeTc7PzqA";